import { supabase } from '../../../shared/lib/supabase';

export interface OrganisationApiConfig {
  id: string;
  organisation_id: string;
  match_details: boolean;
  match_stats: boolean;
  player_stats: boolean;
  tactical_charts: boolean;
  highlights: boolean;
  match_details_nodes: string[] | null;
  match_stats_nodes: string[] | null;
  player_stats_nodes: string[] | null;
  tactical_charts_nodes: string[] | null;
  highlights_nodes: string[] | null;
  match_list_nodes: string[] | null;
  create_match_nodes: string[] | null;
  video_detection_field_paths: string[] | null;
  match_stats_stat_keys: string[] | null;
  player_stats_stat_keys: string[] | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface OrganisationApiConfigUpdate {
  match_details?: boolean;
  match_stats?: boolean;
  player_stats?: boolean;
  tactical_charts?: boolean;
  highlights?: boolean;
  match_details_nodes?: string[] | null;
  match_stats_nodes?: string[] | null;
  player_stats_nodes?: string[] | null;
  tactical_charts_nodes?: string[] | null;
  highlights_nodes?: string[] | null;
  match_list_nodes?: string[] | null;
  create_match_nodes?: string[] | null;
  video_detection_field_paths?: string[] | null;
  match_stats_stat_keys?: string[] | null;
  player_stats_stat_keys?: string[] | null;
  is_active?: boolean;
}

const TABLE = 'organisation_api_config';

/**
 * Get API section config for an organisation. Returns null if no row exists (API defaults to all sections true).
 */
export async function getByOrganisationId(organisationId: string): Promise<OrganisationApiConfig | null> {
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .eq('organisation_id', organisationId)
    .maybeSingle();

  if (error) {
    console.error('organisationApiConfigService.getByOrganisationId', error);
    throw error;
  }
  return data;
}

/**
 * Upsert API section config for an organisation. Creates a row with defaults if missing.
 */
export async function upsert(
  organisationId: string,
  config: OrganisationApiConfigUpdate
): Promise<{ data: OrganisationApiConfig | null; error: string | null }> {
  try {
    const payload = {
      organisation_id: organisationId,
      updated_at: new Date().toISOString(),
      ...config,
    };

    const { data, error } = await supabase
      .from(TABLE)
      .upsert(payload, {
        onConflict: 'organisation_id',
        ignoreDuplicates: false,
      })
      .select()
      .single();

    if (error) {
      console.error('organisationApiConfigService.upsert', error);
      return { data: null, error: error.message };
    }
    return { data, error: null };
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Unknown error';
    return { data: null, error: message };
  }
}
